import { t } from './i18n.js';

import { createFeatureRecovery, LAZY_RETRY_PARAM } from './feature-recovery-controller.js';

let prepareReload = async (_url: URL): Promise<boolean> => true;
let browserRecovery: ReturnType<typeof createFeatureRecovery> | undefined;
let scheduled: ReturnType<typeof setTimeout> | undefined;

export function configureFeatureRecovery(prepare: (url: URL) => Promise<boolean>): void {
  prepareReload = prepare;
}

function showRecovery(retry: () => void): void {
  let notice = document.getElementById('lazy-feature-recovery');
  if (!notice) {
    notice = document.createElement('div');
    notice.id = 'lazy-feature-recovery';
    notice.className = 'lazy-feature-recovery rec:[&#lazy-feature-recovery]:fixed rec:[&#lazy-feature-recovery]:inset-[auto_1rem_1rem] rec:[&#lazy-feature-recovery]:z-[var(--layer-toast,_10000)] rec:[&#lazy-feature-recovery]:flex rec:[&#lazy-feature-recovery]:items-center rec:[&#lazy-feature-recovery]:justify-between rec:[&#lazy-feature-recovery]:gap-[1rem] rec:[&#lazy-feature-recovery]:max-w-[40rem] rec:[&#lazy-feature-recovery]:[margin-inline:auto] rec:[&#lazy-feature-recovery]:p-[1rem] rec:[&#lazy-feature-recovery]:[border:1px_solid_#cbd5e1] rec:[&#lazy-feature-recovery]:rounded-[0.75rem] rec:[&#lazy-feature-recovery]:[background:#fff] rec:[&#lazy-feature-recovery]:[color:#172033] rec:[&#lazy-feature-recovery]:[box-shadow:0_4px_20px_#0003] rec:[&#lazy-feature-recovery]:[font:14px/1.4_system-ui,_sans-serif] rec:[&#lazy-feature-recovery_button]:[flex-shrink:0] rec:[&#lazy-feature-recovery_button]:p-[0.65rem_1rem] rec:[&#lazy-feature-recovery_button]:[border:0] rec:[&#lazy-feature-recovery_button]:rounded-[0.5rem] rec:[&#lazy-feature-recovery_button]:[background:#2563eb] rec:[&#lazy-feature-recovery_button]:[color:#fff] rec:[&#lazy-feature-recovery_button]:font-inherit rec:[&#lazy-feature-recovery_button]:[cursor:pointer] rec:[&#lazy-feature-recovery_button:focus]:[outline:3px_solid_#172033] rec:[&#lazy-feature-recovery_button:focus]:[outline-offset:3px]';
    notice.setAttribute('role', 'alert');
    const message = document.createElement('span');
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = t('lazy_feature.reload');
    const updateConnection = () => {
      const offline = navigator.onLine === false;
      message.textContent = t(offline ? 'lazy_feature.offline_message' : 'lazy_feature.reload_message');
      button.disabled = offline;
    };
    updateConnection();
    window.addEventListener('online', updateConnection);
    window.addEventListener('offline', updateConnection);
    button.addEventListener('click', retry);
    notice.appendChild(message);
    notice.appendChild(button);
    document.body.appendChild(notice);
  }
}

export function installFeatureRecovery(): void {
  if (!('window' in globalThis) || browserRecovery) return;
  const url = new URL(window.location.href);
  const retriedOnLoad = url.searchParams.has(LAZY_RETRY_PARAM);
  url.searchParams.delete(LAZY_RETRY_PARAM);
  if (retriedOnLoad) window.history.replaceState(window.history.state, '', url);
  browserRecovery = createFeatureRecovery({
    retriedOnLoad,
    currentUrl: () => window.location.href,
    isOnline: () => navigator.onLine !== false,
    prepare: (destination) => prepareReload(destination),
    reload: (destination) => {
      window.history.replaceState(window.history.state, '', destination);
      window.location.reload();
    },
    showRetry: showRecovery,
  });

}

export function scheduleFeatureRecovery(): void {
  installFeatureRecovery();
  clearTimeout(scheduled);
  scheduled = setTimeout(() => { void browserRecovery?.recover(); }, 0);
}

export function recoverLazyFeature(options: { resumeUrl?: string; automatic?: boolean } = {}): Promise<void> {
  installFeatureRecovery();
  clearTimeout(scheduled);
  return browserRecovery?.recover(options) ?? Promise.resolve();
}
